import { render, staticRenderFns } from "./adviceForm.vue?vue&type=template&id=55a4e369&scoped=true"
import script from "./adviceForm.vue?vue&type=script&lang=ts"
export * from "./adviceForm.vue?vue&type=script&lang=ts"
import style0 from "./adviceForm.vue?vue&type=style&index=0&id=55a4e369&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55a4e369",
  null
  
)

export default component.exports